import React, { useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Alert from '@material-ui/lab/Alert';
import { useDispatch, useSelector } from "react-redux";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CompanyRep from './company/CompanyRep';

import * as QuestionsActions from '../actions/Questions';

export default function QuestionsDialog() {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');

  // connect to redux
  let errors = useSelector(state => state.questions.errors);
  let open = useSelector(state => state.questions.open);
  let inProgress = useSelector(state => state.questions.inProgress);
  let questions = useSelector(state => state.company.questions);
  let answers = useSelector(state => state.questions.answers);
  let completed = useSelector(state => state.questions.completed);
  let failed = useSelector(state => state.questions.failed);
  let companyName = useSelector(state => state.company.data.name);
  let reps = useSelector(state => state.company.users);

  const dispatch = useDispatch();
  const onClose = () => dispatch(QuestionsActions.closeDialog());
  const onSubmit = () => dispatch(QuestionsActions.submitAnswers());
  const saveAnswer = (id, val) => dispatch(QuestionsActions.recordAnswer(id,val));

  const QuestionItem = (props) => {
    let q = props.question;
    return <div key={q.id}>
      <div style={{marginBottom: 10}}>
        {q.body}
        <RadioGroup row value={answers[q.id]} onChange={(evt) => saveAnswer(q.id, evt.target.value)} >
          {q.options.map( (opt) => <FormControlLabel key={opt} value={opt} control={<Radio color="primary" />} label={opt} /> )}
        </RadioGroup>
      </div>
    </div>
  }

  const FailedMessage = () => {
    return (<div>Thank you for your interest in {companyName}.<br/>Your responses to our qualifying questions indicate that you don't currently meet the requirements for this opportunity.</div>);
  }

  return (
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={onClose}
        aria-labelledby="qq-dialog-title"
        scroll="body"
      >
        <DialogTitle id="qq-dialog-title">
          <CompanyRep profile={reps[0]} />
          </DialogTitle>
        <DialogContent>
          <DialogContentText component='div'>
            { failed ? FailedMessage()  :
            <>
            <Typography variant='h5' style={{marginBottom: 20}}>Please answer the following questions:</Typography>
            {questions.map( (q) => <QuestionItem question={q} key={q.id} />) }
            </> }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          { failed ?
          <Button onClick={onClose} color="inherit">
            Close
          </Button>
          :
          <Button disabled={inProgress || (!completed)}
            onClick={onSubmit}
            color="primary"
            autoFocus>
            Submit answers
          </Button>
          }
        </DialogActions>
        {inProgress ? <LinearProgress /> : '' }
      </Dialog>
  );
}
